import { exportTextFile } from "./nativeTextExport";
import type { GeoArResult } from "../lab-v14/types/GeoArResult";
import type { GeoArFieldOrientation } from "./useGeoArFieldSensors";

const STORAGE_KEY = "thera.geoar.field-beta.evidence.v1";
const MAX_RECORDS = 1200;

export type GeoArFieldEvidence = {
  schemaVersion: "1.0.0";
  checkpoint: "GEO-AR-V1.5-ANDROID-FIELD-BETA";
  observationId: string;
  capturedAt: string;
  mode: "LAB";
  online: boolean;
  position: {
    latitude: number;
    longitude: number;
    altitude: number | null;
    accuracy: number;
    timestamp: number;
    sourceDevice: string;
  };
  orientation: GeoArFieldOrientation;
  calibration: {
    horizontalFov: number;
    verticalFov: number;
    headingOffset: number;
    pitchOffset: number;
  };
  selectedFeatureUuid: string;
  result: GeoArResult | null;
  notes: string;
};

export function loadGeoArEvidence(): GeoArFieldEvidence[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const value = JSON.parse(raw) as unknown;
    return Array.isArray(value) ? value as GeoArFieldEvidence[] : [];
  } catch {
    return [];
  }
}

export function appendGeoArEvidence(record: GeoArFieldEvidence): number {
  const current = loadGeoArEvidence();
  current.push(record);
  const bounded = current.slice(-MAX_RECORDS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(bounded));
  return bounded.length;
}

export async function exportGeoArEvidence() {
  const records = loadGeoArEvidence();
  const payload = {
    exportType: "THERA_GEO_AR_FIELD_BETA_EVIDENCE",
    exportedAt: new Date().toISOString(),
    records,
  };
  const fileName = `thera-geo-ar-field-evidence-${new Date().toISOString().replace(/[:.]/g, "-")}.json`;
  return exportTextFile({
    contents: JSON.stringify(payload, null, 2),
    mimeType: "application/json",
    fileName,
  });
}
